import axios from 'CanExConfig/axios'

const endpoint = candidateId => `/api/candidate/v2/candidate_profiles/${candidateId}/talent_advisor`

export const getTalentAdvisor = async candidateId => {
  const response = await axios(endpoint(candidateId), {
    method: 'GET',
  })

  return response.data
}
